import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';

import { AllowedTimes } from 'src/features/membershipType/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import UpdateMembershipAllowedTimeFormModal
    from 'src/features/membership/components/forms/allowedTime/UpdateMembershipAllowedTimeFormModal';
import DeleteMembershipAllowedTime
    from 'src/features/membership/components/forms/allowedTime/DeleteMembershipAllowedTime';

interface CellAllowedTimeActionsProps extends CellContext<AllowedTimes, unknown> {
    allowedTimesData?: AllowedTimes[];
}
export default function CellMembershipAllowedTimeActions({
    row,
    allowedTimesData,
}: CellAllowedTimeActionsProps) {
    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateMembershipAllowedTimeFormModal
                        selectedAllowedTime={row.original}
                        allowedTimesData={allowedTimesData}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateMembershipAllowedTimeFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>

                <Tooltip>
                    <DeleteMembershipAllowedTime
                        selectedAllowedTime={row.original}
                        allowedTimesData={allowedTimesData}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteMembershipAllowedTime>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
